Backbone = require 'backbone'
Backbone.$ = $

class EmailFormOptimizedContactChannelView extends Backbone.View
  className: 'optimized-contact-channels-view'

  events:
    'click .optimized-email-us': 'optimizedContactByEmail'
    'DOMSubtreeModified .live-chat-container.optimized-contact-channel' : 'handleDisplayOfOptimizedChannels'
    "click .optimized-phone-btn"  : "renderPhoneNumberView"
    'click .live-chat-container.optimized-contact-channel' : 'chatClicked'

  initialize: (options) ->
    @options = options || {}
    _.bindAll.apply(_, [this].concat(_.functions(this)))
    @I18nScope = 'modules.support'
    @model = Groupon.Support.OptimizedContactChannelsModel
    @mainView = @options.mainView
    @emailFormModel = @options.emailFormModel

  render: () ->
    @$el.append toHtml(@model.template, @toHash(), @I18nScope)
    this

  toHash: () ->
    $.extend {isLiveChatEnabled: @isLiveChatEnabled(), isPhonePreferredChannel: @mainView.isPhonePreferredChannel()}, @model.toHash()

  isLiveChatEnabled: () ->
    Groupon.Support.LiveChatModel.isLiveChatEnabled()

  optimizedContactByEmail: (event)->
    @model.hidePreferencedContactChannel()
    @model.showPreferencedContactChannel("email")
    @mainView.renderEmailForm()

  handleDisplayOfOptimizedChannels: ->
    liveChatContainerElem = @model.optimizedLiveChatContainer()
    emailUsParagraphElems = @model.emailRecommendationTextElement()
    phoneParagraphElems = @model.phoneRecommendationTextElement()

    @model.hidePreferencedContactChannel()
    @model.setOptimizedLiveChatDisplayCallBack(@handleDisplayOfOptimizedChannels)

    if @model.optimizedLiveChatVisible()
      showDOMElems liveChatContainerElem
      hideDOMElems [emailUsParagraphElems, phoneParagraphElems]
      @model.showPreferencedContactChannel("chat")
    else
      hideDOMElems liveChatContainerElem
      if @emailFormModel.isMethodOfContactByPhone() or @emailFormModel.isMethodOfContactByPhoneWithEmail()
        @model.showPreferencedContactChannel("phone")
        hideDOMElems emailUsParagraphElems
        showDOMElems phoneParagraphElems
      else
        @model.showPreferencedContactChannel("email")
        hideDOMElems phoneParagraphElems
        showDOMElems emailUsParagraphElems

  handleDisplayOfContactChannels: ->
    @handleDisplayOfOptimizedChannels()

  renderPhoneNumberView: ->
    @model.hidePreferencedContactChannel()
    @model.showPreferencedContactChannel("phone")
    @mainView.renderPhoneNumberView()

  chatClicked: ->
    @model.hidePreferencedContactChannel()
    @model.showPreferencedContactChannel("chat")
    return true

  renderLiveChat: ()->
    @mainView.renderLiveChat({
      liveChatMode: 'static',
      liveChatType: Groupon.Support.LiveChatModel.getOptimizedLiveChatType()
    })

module.exports = EmailFormOptimizedContactChannelView
